import { render, staticRenderFns } from "./SubArticleApp.vue?vue&type=template&id=87c28e4c&"
import script from "./SubArticleApp.vue?vue&type=script&lang=js&"
export * from "./SubArticleApp.vue?vue&type=script&lang=js&"
import style0 from "./SubArticleApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports